export default __webpack_public_path__ + "static/media/logobobs.0d5da4f4.png";